import React, { createContext, useContext, useEffect, useState } from "react";
import { API } from "@/lib/api";

export const DEFAULT_BRANDING = {
  product_name: "Pravadh GovernX",
  product_short: "GovernX",
  tagline: "Connect. Clean. Govern.",
  logo_url: "",
  badge: "GX",
  mark_letter: "P",
  primary: "221 83% 53%",
  accent: "37 99% 50%",
  from_name: "Pravadh GovernX",
  assistant_name: "EMIE",
  custom_domain: "",
};

const BrandingContext = createContext(DEFAULT_BRANDING);

function applyBranding(data) {
  const root = document.documentElement;
  if (data.primary) root.style.setProperty("--primary", data.primary);
  if (data.accent) root.style.setProperty("--accent", data.accent);
  // Page titles and descriptions come from SeoManager. Only a white-label
  // install (a different product name) replaces them with its own brand.
  if (data.product_name && data.product_name !== DEFAULT_BRANDING.product_name) {
    const title = data.tagline ? `${data.product_name} — ${data.tagline}` : data.product_name;
    document.title = title;
    const desc = document.querySelector('meta[name="description"]');
    if (desc && data.tagline) desc.setAttribute("content", `${data.product_name} — ${data.tagline}`);
  }
}

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULT_BRANDING);

  useEffect(() => {
    fetch(`${API}/public/branding`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : DEFAULT_BRANDING))
      .then((data) => {
        const next = { ...DEFAULT_BRANDING, ...data };
        setBranding(next);
        applyBranding(next);
      })
      .catch(() => {});
  }, []);

  return <BrandingContext.Provider value={branding}>{children}</BrandingContext.Provider>;
}

export function useBranding() {
  return useContext(BrandingContext);
}
